import styled from "styled-components";


export const Wrapper = styled.div`
  text-align: center;
  width: 100%;
`;


export const ContentWrapper = styled.div`
    max-width: 40%;
    margin: 40px auto auto;
    display: flex;
    justify-content: center;
    flex-direction: column;
    gap: 30px;
    padding: 0 40px 40px;

    @media (max-width: 768px) {
        max-width: 100%;
        padding: 0 20px 20px;
    }

    div {
        text-align: left;
    }
`;


export const InputWrapper = styled.div`
  width: 100%;
  text-align: left;
  h1 {
    font-family: Inter;
    font-size: 14px;
    font-weight: 500;
    line-height: 16px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
  }
  p {
    font-family: Inter;
    font-size: 12px;
    font-weight: 400;
    line-height: 15.6px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
  }
`;

export const Error = styled.span`
  color: #f9123b;
  font-family: Inter;
  text-align: right;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 15.6px;
`;

export const ItemWrapper = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
`;

export const RateBox = styled.div`
    height: 40px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    border-radius: 8px;
    background-color: #f9f9f9;

    span {
        color: #000000;
        font-size: 12px;
        font-weight: 400;
        line-height: 15.6px;
    }

    .fee-box {
        display: flex;
        align-items: center;
        gap: 5px;
    }
`;